<template>
  <div class="clear-table-box">
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column
        prop="clearTime"
        label="清算日期"
        :render-header="timeHeader"
        min-width="13.9%"
      >
      </el-table-column>
      <el-table-column prop="tradeTime" label="交易日期" min-width="15.8%"> </el-table-column>
      <el-table-column prop="payChannelName" label="支付通道" align="right" min-width="12.2%" />
      <el-table-column
        prop="sumAmount"
        label="交易金额"
        align="right"
        :render-header="sumHeader"
        min-width="16.1%"
      >
        <template slot-scope="scope">
          {{ scope.row.sumAmount | numberFormat }}
        </template>
      </el-table-column>
      <el-table-column prop="commission" align="right" label="手续费" min-width="10.5%">
        <template slot-scope="scope">
          <span>
            {{ scope.row.commission | numberFormat }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="已清算金额"
        align="right"
        :render-header="amountHeader"
        min-width="13.4%"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.amount | numberFormat }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import crypto from 'crypto';

export default {
  data() {
    return {
      createTime: '',
      id: '',
      outOrderNo: '',
      extNum: '',
      payTypeName: '',
      amount: '',
      payStatusName: '',
      note: '',
      refundstatus: '',
      isInvoiced: '',
      applytime: '',
      refundid: '',
      createUser: '',
      refundmoney: '',
      refundReason: '',
      time: '',
      ordernum: '',
      paytype: '',
      paymoney: '',
      reason: '',
      reasonerr: '',
      password: '',
      pderr: '',
      refund: false,
      orderdetails: false,
      details: false,
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    timeHeader(h, { column, $index }) {
      return (
        <span>
          <span>清算日期</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="目前系统支持的清算周期：T+1"
            placement="top"
          >
            <i class="iconfont icon-question u-curp"></i>
          </el-tooltip>
        </span>
      );
    },
    sumHeader(h, { column, $index }) {
      return (
        <span>
          <span>交易金额</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              1 该交易日交易成功的金额总和
              <br />
              2 扫码交易统计时间范围为d日的00:00:00-23:59:59；
              <br />3 pos刷卡及预授权交易统计的时间范围为d-1日的23:00:01-d日的23:00:00
            </div>
            <i class="iconfont icon-question u-curp"></i>
          </el-tooltip>
        </span>
      );
    },
    amountHeader(h, { column, $index }) {
      return (
        <span>
          <span>已清算金额</span>
          <el-tooltip
            class="item"
            effect="dark"
            content=" 该清算日清算成功的金额总和"
            placement="top"
          >
            <i class="iconfont icon-question u-curp"></i>
          </el-tooltip>
        </span>
      );
    },
    handleClose(done) {
      done();
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.el-tooltip__popper div {
  font-size: 14px;
}
.clear-table-box {
  min-height: 350px;
  margin-top: 16px;
  .iconfont.warn {
    color: #e6a23c;
  }
  .e-mt12 {
    margin-top: 12px;
  }
  .iconfont.ok {
    color: #67c23a;
  }
  .iconfont.err {
    color: #f56c6c;
  }
  .iconfont.close {
    color: #cccccc;
  }
  .u-statusblue {
    color: #409eff;
    cursor: pointer;
  }
  .u-curp {
    cursor: pointer;
    color: #606266;
    margin-left: 4px;
  }
}
</style>
